import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { products } from '../data/products';
import './ProductDetail.css';

const ProductDetail = () => {
  const { id } = useParams();
  const product = products.find(p => p.id === parseInt(id));

  if (!product) {
    return (
      <div className="not-found">
        <div className="container">
          <h2>Product not found</h2>
          <Link to="/products">← Back to Products</Link>
        </div>
      </div>
    );
  }

  const related = products.filter(p => p.category === product.category && p.id !== product.id).slice(0, 3);

  return (
    <div className="product-detail">
      {/* Breadcrumb */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span>→</span>
            <Link to="/products">Products</Link>
            <span>→</span>
            <span className="bc-current">{product.name}</span>
          </div>
        </div>
      </div>

      {/* Main Detail */}
      <div className="detail-hero" style={{ '--product-color': product.color }}>
        <div className="container">
          <div className="detail-inner">
            {/* Image Panel */}
            <div className="detail-image-panel">
              <div className="detail-image-area">
                {product.image ? (
                  <img src={product.image} alt={product.name} className="detail-img" />
                ) : (
                  <div className="detail-img-placeholder">
                    <div className="dip-icon">⚙️</div>
                    <h4>{product.name}</h4>
                    <p>Image coming soon</p>
                  </div>
                )}
              </div>

              {/* Category tag */}
              <div className="detail-cat-tag" style={{ background: product.color }}>
                {product.category}
              </div>

              {/* Quick contact */}
              <div className="detail-quick-contact">
                <h4>Enquire About This Product</h4>
                <a href={`tel:+919848027990`} className="detail-call-btn">📞 Call Now</a>
                <a href={`mailto:srisaiengs@gmail.com?subject=Enquiry: ${product.name}`} className="detail-email-btn">✉️ Email Us</a>
              </div>
            </div>

            {/* Info Panel */}
            <div className="detail-info-panel">
              <div className="detail-badge-row">
                <span className="detail-cat-badge" style={{ color: product.color, borderColor: product.color }}>
                  {product.category}
                </span>
                <span className="detail-id-badge">Model #{product.id.toString().padStart(3, '0')}</span>
              </div>

              <h1 className="detail-title">{product.name}</h1>
              <p className="detail-tagline">{product.tagline}</p>

              <div className="detail-accent" style={{ background: product.color }} />

              <p className="detail-description">{product.description}</p>

              {/* Specs Table */}
              <div className="detail-specs">
                <h3 className="specs-title">Technical Specifications</h3>
                <div className="specs-table">
                  <div className="specs-header">
                    <span>Model</span>
                    <span>Capacity</span>
                    <span>Power Required</span>
                    {product.specs[0]?.speed && <span>Speed</span>}
                    {product.specs[0]?.dims && <span>Dimensions</span>}
                    {product.specs[0]?.voltage && <span>Voltage</span>}
                  </div>
                  {product.specs.map((spec, i) => (
                    <div className="specs-row" key={i}>
                      <span>{spec.model}</span>
                      <span>{spec.capacity}</span>
                      <span>{spec.power}</span>
                      {spec.speed && <span>{spec.speed}</span>}
                      {spec.dims && <span>{spec.dims}</span>}
                      {spec.voltage && <span>{spec.voltage}</span>}
                    </div>
                  ))}
                </div>
              </div>

              <div className="detail-actions">
                <Link to="/contact" className="detail-quote-btn">Request a Quote</Link>
                <a href="tel:+919848027990" className="detail-phone-btn">📞 9848027990</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Related Products */}
      {related.length > 0 && (
        <div className="related-section">
          <div className="container">
            <h3 className="related-title">Related Products in <span>{product.category}</span></h3>
            <div className="related-grid">
              {related.map(rel => (
                <Link to={`/products/${rel.id}`} key={rel.id} className="related-card" style={{ '--rc': rel.color }}>
<div className="rc-image">
  <div className="rc-placeholder">
    <img src={rel.image} alt={rel.name} />
  </div>
</div>
                  <div className="rc-body">
                    <div className="rc-accent" style={{ background: rel.color }} />
                    <h4>{rel.name}</h4>
                    <p>{rel.tagline}</p>
                    <span className="rc-capacity">{rel.specs[0]?.capacity}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}

      <div className="detail-back-bar">
        <div className="container">
          <Link to="/products" className="back-link">← Back to All Products</Link>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;